/**
 * values for setting the 'sizing' in form fields
 */
import { locale } from './../../ModuleEditor/util/locale-wrapper';
import { getSizeInfo } from './responsiveSizes';

const FIELD_SIZINGS = {
  PIXEL:      'pixel',
  PERCENT:    'percent',
  RESPONSIVE: 'responsive',
};

const FIELD_SIZING_LIST = [
  { text: locale('Pixel'), value: FIELD_SIZINGS.PIXEL },
  { text: locale('Percent'), value: FIELD_SIZINGS.PERCENT },
  { text: locale('Responsive'), value: FIELD_SIZINGS.RESPONSIVE },
];

const FIELD_SIZINGS_ALL = _.values(FIELD_SIZINGS, 'value');

const SIZE_CONSTRAINTS = {
  MIN_PIXEL_VALUE:   20, // This varies by module type, get from moduleTypes data
  MAX_PIXEL_VALUE:   1200,
  MAX_PIXEL_HEIGHT:  250,
  MIN_PERCENT_VALUE: 5,
  MAX_PERCENT_VALUE: 100,
};

/**
 * Calculates either the width or height of a field based on the sizing type
 * and given numeric or responsive size.
 * @param {FIELD_SIZINGS} sizing - enum indicating pixel, percent, or responsive
 * @param {number} numericSize - number representing size in pixels or percent
 * @param {RESPONSIVE_SIZES} responsiveSize - enum indicating the responsive size value
 *
 * @returns {string} representing field size as a percentage
 */
const calculateFieldSizeAsPercentage = (
  sizing,
  numericSize,
  responsiveSize,
  maxPixels = SIZE_CONSTRAINTS.MAX_PIXEL_VALUE
) => {
  let fieldSize;
  switch (sizing) {
    case FIELD_SIZINGS.PERCENT:
      fieldSize = `${numericSize}%`;
      break;
    case FIELD_SIZINGS.PIXEL:
      fieldSize = `${(numericSize / maxPixels) * 100}%`;
      break;
    case FIELD_SIZINGS.RESPONSIVE:
      fieldSize = getSizeInfo(responsiveSize, 0).percent;
  }
  return fieldSize;
};

export { FIELD_SIZINGS, FIELD_SIZING_LIST, FIELD_SIZINGS_ALL, SIZE_CONSTRAINTS, calculateFieldSizeAsPercentage };

export default FIELD_SIZINGS;
